import React from 'react';
import { Router, RouterContext } from 'react-router';
import useRouterHistory from 'react-router/lib/useRouterHistory';
import { createHistory } from 'history';

import config from '../config';
import rootRoute from '../routes';

import GlobalErrorBoundary from './GlobalErrorBoundary';
import Refocus from './RefocusRouteContent';

export default class Root extends React.PureComponent {

    // eslint-disable-next-line react-hooks/rules-of-hooks
    history = useRouterHistory(createHistory)({
        basename: config.get('baseHref')
    });

    specialRender = (props) => {
        return <Refocus routes={props.routes}><RouterContext { ...props } /></Refocus>;
    };

    render () {
        return (
            <GlobalErrorBoundary>
                <Router history={ this.history } routes={ rootRoute } render={ this.specialRender }/>
            </GlobalErrorBoundary>
        );
    }
}
